class OneSignal {
    constructor() {
        this.domInjection();
    }
    domInjection() {
        let _this = this;
        $('[data-id="widget-one-signal"]').each(function(){
            let _oneSignalId = $(this).data("key");
            $(this).removeAttr("data-key");
            let libScript = _this.createLibaryScript();
            let initScript = _this.createInitLibaryScript(_oneSignalId);

            _this.appendElementToBody(libScript);
            _this.appendBodyElementToBody(initScript);
        });

    }
    appendElementToBody(element) {
        let bodyElem = document.getElementsByTagName("body")[0];

        bodyElem.append(element);
    }
    appendBodyElementToBody(element) {
        let bodyElem = document.getElementsByTagName("body")[0];

        bodyElem.append(element);
    }
    createLibaryScript() {
        let newScriptElement = document.createElement("script");

        newScriptElement.src = "https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js";
        newScriptElement.type = 'text/javascript';
        newScriptElement.async = false;
        newScriptElement.defer = true;

        return newScriptElement;
    }
    createInitLibaryScript(appId) {
        return this.createInitializationScript(appId);
    }
    createInitializationScript(appId) {
        let newScriptElement = document.createElement("script");

        newScriptElement.type = 'text/javascript';

        let textN = document.createTextNode('window.OneSignalDeferred = window.OneSignalDeferred || [];\n' +
            '      OneSignalDeferred.push(async function(OneSignal) {\n' +
            '        await OneSignal.init({\n' +
            '          appId: "' + appId +'"\n' +
            '        });\n' +
            '      });');

        newScriptElement.appendChild(textN);

        return newScriptElement;
    }
}

export default OneSignal;